import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { removeOrganisations } from '@api/organisations';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';

import { ESnackbarTypes } from '@enums/common';

import { ORGANISATIONS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateRemoveOrganisations = (onSettledCallbacks?: Array<() => void>) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleDeleteOrganisations,
		isLoading: isLoadingDeleteOrganisations,
	} = useMutation({
		mutationKey: [ORGANISATIONS],
		mutationFn: removeOrganisations,
		onSuccess: () => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			dispatch(setSnackbar({
				message: responseMessages.removedOrganisations,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([ORGANISATIONS]);
		},
		onError: (err: IResponseError) => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			handleErrorFromMessage(err);
		},
	});

	return {
		handleDeleteOrganisations,
		isLoadingDeleteOrganisations,
	};
};
